import React from "react";

export default function SponsorsPage() {
  return <div>sponsors.page</div>;
}
